import { parseJwt, willExpireSoon } from "../utils/auth"
import { loginPathFor } from "../utils/safeRedirect"

const CHECK_INTERVAL = 10 * 60 * 1000

export default defineNuxtPlugin((nuxtApp) => {
	const router = useRouter()
	let intervalId: number | null = null

	const startAutoRefresh = () => {
		if (intervalId) return

		intervalId = window.setInterval(() => {
			const token = useCookie("auth_token").value
			if (!token) return

			try {
				const payload = parseJwt(token)
				const expiresSoon = willExpireSoon(payload.exp)
				if (expiresSoon) {
					window.dispatchEvent(new Event("token-expiring"))
				}
			} catch {
				stopAutoRefresh()
				useCookie("auth_token").value = null
				navigateTo(loginPathFor(router.currentRoute.value.fullPath))
			}
		}, CHECK_INTERVAL)
	}

	const stopAutoRefresh = () => {
		if (intervalId) {
			clearInterval(intervalId)
			intervalId = null
		}
	}

	startAutoRefresh()

	nuxtApp.provide("stopAutoRefresh", stopAutoRefresh)
})
